import React from 'react';

// Import optimized images - progressive enhancement approach
import heroImageMobile from '@/assets/landing-hero-mobile.webp';
import heroImageTablet from '@/assets/landing-hero-bg-1024-optimized.webp';
import heroImageDesktop from '@/assets/landing-hero-bg-1920-optimized.webp';
import heroImageFallback from '@/assets/landing-hero-bg-compressed.jpg';

interface ResponsiveHeroImageProps {
  alt?: string;
  className?: string;
}

const ResponsiveHeroImage: React.FC<ResponsiveHeroImageProps> = ({ 
  alt = "Business analytics and growth assessment tools", 
  className = "absolute inset-0 w-full h-full object-cover"
}) => {
  return (
    <>
      {/* Picture element for responsive WebP images - mobile-first optimization */}
      <picture>
        <source
          media="(max-width: 640px)"
          srcSet={`${heroImageMobile} 640w`}
          sizes="100vw"
          type="image/webp"
        />
        <source
          media="(min-width: 641px) and (max-width: 1024px)"
          srcSet={`${heroImageTablet} 1024w`}
          sizes="100vw"
          type="image/webp"
        />
        <source
          media="(min-width: 1025px)"
          srcSet={`${heroImageDesktop} 1920w, ${heroImageTablet} 1024w`}
          sizes="100vw"
          type="image/webp"
        />
        {/* Fallback for browsers that don't support WebP */}
        <img
          src={heroImageFallback}
          alt={alt}
          className={className}
          loading="eager"
          decoding="async"
        />
      </picture>
    </>
  );
};

export default ResponsiveHeroImage;